<div class="rs-barchart" data-rslib-css-load="rslib.css.barchart">
  <div class="rs-flex-row rs-flex-middle">
    <div class="rs-flex-column rs-order-s2 text-center">
      <p
        id="ac-barchart-spinner"
        data-cy="evolutionLoader"
        class="rs-font-pxB"
      ></p>
    </div>
    <div class="rs-flex-column rs-flex-shrink rs-order-s3">
      <div class="rs-navigation rs-block">
        <div class="rs-navigation-arrow rs-navigation-arrow-next rs-disabled">
          <button
            class="rs-navigation-trigger"
            attr.aria-label="{{
              'bills.evolutionChart.web.nextMonths' | translate
            }}"
            disabled=""
          >
            <i
              class="icon-Arrowbutton icon-lh icon-large"
              attr.aria-label="{{
                'bills.evolutionChart.web.nextMonths' | translate
              }}"
            ></i>
          </button>
        </div>
      </div>
    </div>

    <div class="rs-flex-column rs-flex-shrink rs-order-s1">
      <div class="rs-navigation rs-block">
        <div class="rs-navigation-arrow rs-navigation-arrow-prev rs-disabled">
          <button
            class="rs-navigation-trigger"
            attr.aria-label="{{
              'bills.evolutionChart.web.previousMonths' | translate
            }}"
            disabled=""
          >
            <i
              class="icon-Arrowbutton-left icon-lh icon-large"
              attr.aria-label="{{
                'bills.evolutionChart.web.previousMonths' | translate
              }}"
            ></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <p class="rs-txt-s3 text-right rs-padding-bottom1">
    <span class="show-for-sr"
      >{{ 'bills.evolutionChart.web.maximumValue' | translate }} </span
    >€
  </p>

  <div class="rs-barchart-content">
    <table class="rs-barchart-graph" aria-labelledby="ac-barchart-spinner">
      <thead class="show-for-sr">
        <tr>
          <th scope="col">
            {{ 'bills.evolutionChart.web.month' | translate }}
          </th>
          <th scope="col">
            {{ 'bills.evolutionChart.web.billValue' | translate }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td colspan="2" class="rs-barchart-nodata rs-pos-mc">
            <div
              class="rs-spinner rs-no-margin-bottom"
              role="alert"
              aria-live="polite"
              attr.aria-label="{{
                'bills.evolutionChart.web.graphLoading' | translate
              }}"
              [attr.title]="'bills.evolutionChart.web.graphLoading' | translate"
              aria-busy="true"
            ></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div
  class="panel rs-h-s3 rs-wd-s14 rs-bg-skeleton rs-anim-loading rs-margin-bottom3"
></div>
<div
  class="panel rs-h-s3 rs-wd-s25 rs-wd-m35 rs-padding-bottom1 rs-bg-skeleton rs-anim-loading rs-margin-bottom1"
></div>
<div class="panel rs-h-s3 rs-wd-s14 rs-bg-skeleton rs-anim-loading"></div>
<div
  class="panel rs-h-s3 rs-wd-s25 rs-wd-m35 rs-bg-skeleton rs-anim-loading rs-margin-bottom1"
></div>
<div class="panel rs-h-s3 rs-wd-s14 rs-bg-skeleton rs-anim-loading"></div>
